import { useState, useEffect } from 'react';
import { map } from 'lodash'

import evaluacionesDB from '../../../documents/Primaria/evaluaciones.json';

import { Col, Container, Row, Spinner } from 'react-bootstrap';
import ReturnBar from '../../../components/ReturnBar/ReturnBar';
import CardEvaluaciones from '../../../components/Cards/CardEvaluaciones/CardEvaluaciones';
import PdfModal from '../../../components/Modal/PdfModal/PdfModal';
import './Evaluaciones.scss';

export default function Evaluaciones() {

    const [showModal, setShowModal] = useState(false);
    const [titleModal, setTitleModal] = useState("");
    const [contentModal, setContentModal] = useState(null);
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setData(evaluacionesDB);
        setIsLoading(false);
    }, []);

    return (
        <div className="evaluaciones">
            <ReturnBar />
            {
                isLoading ? (
                    <div className="evaluaciones__loading">
                        <Spinner animation="border" />
                    </div>
                ) : (
                    <Container>
                        <h2 className="evaluaciones__titulo">Evaluaciones</h2>
                        <Row>
                            {
                                map(data, items => (
                                    <Col lg={12} md={12} className="gy-5" key={items.id} >
                                        <CardEvaluaciones
                                            element={items}
                                            setShowModal={setShowModal}
                                            setTitleModal={setTitleModal}
                                            setContentModal={setContentModal}
                                        />
                                    </Col>
                                ))
                            }
                        </Row>
                    </Container>
                )
            }

            <PdfModal show={showModal} setShow={setShowModal} title={titleModal}>
                {contentModal}
            </PdfModal>
        </div>
    );
}